import { Button, Space, Table, Tabs, Tag, Tooltip } from "antd";
import { useEffect, useState } from "react";
import {
  PlusOutlined,
  DownloadOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { arquivosRequest } from "./arquivosRequest";
import { DeleteOutlined } from "@ant-design/icons";
import { ModalInserir } from "./modal";
import { ModalDelete } from "./modalDelete";
import { colors } from "../../../Utils/temas";
import { useUserContext } from "../../../contexts/usersContext";
import { ModalAuthorization } from "./modalAuthorization";

const { TabPane } = Tabs;

export const AtualizacaoRemota = () => {
  const [arquivos, setArquivos] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [id, setId] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [idAuthorization, setIdAuthorization] = useState(false);
  const [openAuthorization, setOpenAuthorization] = useState(false);

  const [filtros, setFiltros] = useState({ tipo_arquivo: "S" });

  const { currentUser } = useUserContext();

  useEffect(() => {
    listaArquivos(currentPage, pageSize, filtros);
  }, [filtros, openAuthorization, currentPage, pageSize]);

  const columns = [
    { title: "Nome arquivo", dataIndex: "nome_arquivo" },
    { title: "Usuário", dataIndex: "usuario_nome" },
    {
      title: "Data arquivo",
      dataIndex: "data_arquivo",
      render: (value) => {
        return <text>{formatarData(value)}</text>;
      },
    },
    {
      title: "Tipo arquivo",
      dataIndex: "tipo_arquivo",
      render: (value) => {
        const labels = {
          S: "Sistema",
          D: "Dependência",
          C: "Console",
          E: "Serviço",
          I: "Instalador",
        };
        return <text>{labels[value] ?? ""}</text>;
      },
    },
    { title: "Sistema descrição", dataIndex: "sistema_descricao" },
    {
      title: "Autorizado",
      dataIndex: "autorizacao",
      render: (value) => (
        <Tag color={value ? "green" : "red"}>{value ? "Sim" : "Não"}</Tag>
      ),
    },
    {
      title: "Ações",
      render: (_, render) => (
        <Space size="small">
          <Tooltip title="Autorização">
            <CheckCircleOutlined
              onClick={() => {
                !render.autorizacao && handleAuthorization(render.id);
              }}
              style={{
                color: !render.autorizacao ? "#252525" : "grey",
                cursor: !render.autorizacao ? "pointer" : "default",
              }}
            />
          </Tooltip>
          {currentUser.is_staff && (
            <Tooltip title="Deletar">
              <DeleteOutlined onClick={() => handleDelete(render.id)} />
            </Tooltip>
          )}
          <Tooltip title="Download">
            <DownloadOutlined
              onClick={() => baixarArquivo(render.link_arquivo)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const handleDelete = (value) => {
    setOpenDelete(true);
    setId(value);
  };

  const listaArquivos = async (page, pageSize, params) => {
    setLoading(true);
    try {
      const response = await arquivosRequest.getArquivos(
        page,
        pageSize,
        params,
      );
      if (response.status === 200 || response.status === 201) {
        const { results, count } = response.data;
        setLoading(false);
        setArquivos(results);
        setTotalRecords(count);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const formatarData = (data) => {
    const date = new Date(data);
    const dataFormatada = date.toLocaleString().split(",");
    return dataFormatada;
  };

  const baixarArquivo = (link) => {
    const element = document.createElement("a");
    element.href = link;
    element.download = "teste.zip";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const tiposArquivos = [
    { descricao: "Sistema", value: "S" },
    { descricao: "Dependência", value: "D" },
    { descricao: "Console", value: "C" },
    { descricao: "Serviço", value: "E" },
    { descricao: "Instalador", value: "I" },
  ];

  const handleAuthorization = (item) => {
    setIdAuthorization(item);
    setOpenAuthorization(true);
  };

  return (
    <>
      {currentUser.is_staff && (
        <div style={{ padding: 10 }}>
          <Button
            icon={<PlusOutlined />}
            onClick={() => setOpen(true)}
            style={{
              background: colors.secondary,
              fontWeight: "500",
              color: "white",
            }}
            className="botao"
          >
            Inserir
          </Button>
        </div>
      )}

      <Tabs
        type="card"
        size="large"
        onChange={(e) => {
          setCurrentPage(1);
          setFiltros({ tipo_arquivo: e });
        }}
      >
        {tiposArquivos.map((item) => (
          <TabPane
            tab={item.descricao}
            key={item.value}
            style={{ marginTop: -16 }}
          >
            <Table
              columns={columns}
              dataSource={arquivos}
              rowKey="id"
              pagination={{
                total: totalRecords,
                current: currentPage,
                pageSize,
                showSizeChanger: totalRecords > 50,
                pageSizeOptions: ["10", "25", "50", "100"],
                onShowSizeChange: (page, size) => {
                  setCurrentPage(page);
                  setPageSize(size);
                },
                onChange: (page, newPageSize) => {
                  setCurrentPage(page);
                  if (newPageSize !== pageSize) {
                    setPageSize(newPageSize);
                  }
                },
                locale: { items_per_page: "" },
                showTotal: (total) => (
                  <span
                    style={{
                      fontWeight: "500",
                      position: "absolute",
                      left: "1%",
                    }}
                  >
                    Quantidade: {total}
                  </span>
                ),
              }}
              loading={loading}
              scroll={{ x: true }}
            />
          </TabPane>
        ))}
      </Tabs>

      <ModalInserir
        onCancel={() => setOpen(false)}
        visible={open}
        atualizarLista={() => listaArquivos(currentPage, pageSize, filtros)}
        tipoArquivo={filtros.tipo_arquivo}
      />
      <ModalDelete
        onCancel={() => setOpenDelete(false)}
        visible={openDelete}
        estadoArquivos={setArquivos}
        id={id}
      />

      <ModalAuthorization
        onCancel={() => setOpenAuthorization(false)}
        visible={openAuthorization}
        id={idAuthorization}
      />
    </>
  );
};
